import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { rules } from "../../../siteData/rules";
import { useRef } from "react";

const EditSkillPop = ({ handleUpdateDegree, handleChange, categoryData, handleModalClose }) => {
    const [form] = Form.useForm();

    form.setFieldsValue({
        type: categoryData.type
    });

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => handleUpdateDegree(e, form)}
                initialValues={categoryData}
                scrollToFirstError
                className="attached_courses-add_skill"
            >
                <h2>Edit degree name</h2>
                <Form.Item name="type" rules={rules.degreeName} className="form_group">
                    <input autoComplete={"off"} onChange={handleChange} name="type" type="text" className="form_control" autoFocus />
                </Form.Item>
                <div className="form_group form_footer">
                    <FilledButton onClick={() => handleModalClose()} type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" className="btn btn_primary" value="Update" />
                </div>
            </Form>
        </div>
    )
};

export default EditSkillPop;